import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {actions as actionModal} from "../../store/sliceModal";
import {actions as actionApp} from "../../store/sliceApp";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {PageCamerasArticle, PageCamerasContainer, PageCamerasText} from "./PageCamerasStyle";
import cameraIcon from "../../image/camera.png";
import {fetchCameraList} from "../../fetch/RequestVideo";
import {actions as actionCamera, ICameraLive} from "../../store/sliceCamera";
import {Button} from "react-bootstrap";


export interface Camera {
    name: string;
    location: string;
    share: boolean;
}

const PageCameras: FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const [cameras, setCameras] = useState<Array<Camera>>([])

    useEffect(() => {
        dispatch(actionApp.setCameras())
        fetchCameraList().then(resp => {
            if (resp.isSuccess) {
                let cameraList: Camera[] = resp.data;
                setCameras(cameraList)

               let cameraLives: ICameraLive[] = cameraList.map((camera) => {
                   return {name: camera.name, sound: false} as ICameraLive
               })
                dispatch(actionCamera.init(cameraLives))
            }
        })
    }, [])

    const showAlCamera = useCallback(() => {
        dispatch(actionModal.showCameraAllModal({title: "Все камеры", name: cameras?.map(camera => camera.name)}))
    }, [cameras])

    return (
        <PageCamerasContainer>
            <h1>Домашние камеры</h1>
            {cameras.length > 0 && <Button style={{marginBottom: "10px"}} variant="outline-success" onClick={() => showAlCamera()}>
                Все камеры
            </Button> }
            {/*<video src={media} autoPlay={true}></video>*/}
            <div style={{display: "flex", gap: "10px"}}>
                {cameras?.map(camera => {
                    return (
                    <PageCamerasArticle onClick={() => dispatch(actionModal.showCameraModal({title: camera.location, name: camera.name}))}>
                        <img style={{width: "100px"}} src={cameraIcon} alt={"camera"}/>
                        <PageCamerasText>{camera.location}</PageCamerasText>
                        {camera?.share && <span style={{position: "absolute", top: 5, right: 5, color: "green"}}>SHARE</span>}
                    </PageCamerasArticle>
                    )
                })}
            </div>

        </PageCamerasContainer>
    )
}

export default memo(PageCameras)
